module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Your file cannot be processed")]), _vm._v(" "), _c('p', [_vm._v("We cannot work on your file for an appeal procedure after a visa refusal. There are different reasons :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n  If you have made a mistake in your answers , you can "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("restart")]), _vm._v(" the questionnaire\n  or contact us by email "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onClickContact()
      }
    }
  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(" to ask for our expert opinion.\n  ")], 1), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "0px",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContact()
      }
    }
  }, [_vm._v("Contact us")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/justice-scale.svg",
      "width": "100%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("The appeal has to be done within the "), _c('b', [_vm._v("2 months after ")]), _vm._v(" your visa refusal or after your appeal to the Appeals Board on Visa Refusals.")]), _vm._v(" "), _c('li', [_vm._v("You indicated that your visa has not been refused ! We can't do anything for you")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83236cca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenRefused.vue
// module id = 742
// module chunks = 3